export class JobSaveRequest {
  jobTypeId: string;
  jobScheduleId: string;
}
